// Purge des donnees personnelles conservees en local (RGPD).
// Appelee a la deconnexion et apres la suppression du compte : les brouillons de
// commande (adresse, telephone), les profils invites de l'onboarding (allergies,
// aversions) et les marqueurs de suivi ne doivent pas survivre a la personne.
// Le marqueur de fin de parcours de l'onboarding est conserve pour ne pas rejouer
// le film d'accueil a la prochaine ouverture.

import { useOnboardingStore } from '../stores/onboarding';

const LOCAL_KEYS = ['clocook_order_draft', 'clocook_b2b_draft'];
const SESSION_KEYS = ['clocook_pending_order', 'clocook_product_images'];
const TRACKED_ORDER_PREFIX = 'tracked_order_';

function safeRemove(storage, key) {
    try { storage.removeItem(key); } catch (e) { /* stockage indisponible */ }
}

function removeByPrefix(storage, prefix) {
    try {
        const keys = [];
        for (let i = 0; i < storage.length; i++) {
            const k = storage.key(i);
            if (k && k.startsWith(prefix)) keys.push(k);
        }
        keys.forEach((k) => safeRemove(storage, k));
    } catch (e) { /* stockage indisponible */ }
}

const ONBOARDING_KEY = 'clocook_onboarding_v1';

/** Vide les profils invites et le brouillon de l'onboarding, en gardant le marqueur de fin */
function purgeOnboarding() {
    try {
        const onboarding = useOnboardingStore();
        onboarding.guestProfiles = [];
        onboarding.orderDraft = { mealsByProfileKey: {}, extras: [] };
    } catch (e) {
        // Pinia pas encore actif : on reecrit la cle brute en ne vidant que les
        // donnees personnelles, les marqueurs introSeen / flowCompletedAt restent.
        if (typeof localStorage === 'undefined') return;
        try {
            const raw = localStorage.getItem(ONBOARDING_KEY);
            if (!raw) return;
            const state = JSON.parse(raw);
            if (!state || typeof state !== 'object') return;
            localStorage.setItem(ONBOARDING_KEY, JSON.stringify({
                ...state,
                guestProfiles: [],
                orderDraft: { mealsByProfileKey: {}, extras: [] }
            }));
        } catch (err) {
            // JSON illisible : on retire la cle plutot que de garder des donnees inconnues.
            safeRemove(localStorage, ONBOARDING_KEY);
        }
    }
}

export function purgeLocalUserData() {
    if (typeof window === 'undefined') return;
    purgeOnboarding();
    if (typeof localStorage !== 'undefined') {
        LOCAL_KEYS.forEach((k) => safeRemove(localStorage, k));
        removeByPrefix(localStorage, TRACKED_ORDER_PREFIX);
    }
    if (typeof sessionStorage !== 'undefined') {
        SESSION_KEYS.forEach((k) => safeRemove(sessionStorage, k));
        removeByPrefix(sessionStorage, TRACKED_ORDER_PREFIX);
    }
}
